/**
 * Button for clicking follow on an Employer profile
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import i18n from '../../../shared/locales/no.json';
import { Consumer } from './FollowButtonContext';

export const REPROMPT_SHORT = 18 * 60 * 60 * 1000; // 18 hours
export const REPROMPT_LONG = 3 * 31 * 24 * 60 * 60 * 1000; // ~ 3 months

class FollowButton extends Component {
    static propTypes = {
        id: PropTypes.string.isRequired,
        followCompany: PropTypes.shape({
            inprogressFollowUnFollow: PropTypes.bool,
            detailsFetched: PropTypes.bool,
            isFollowing: PropTypes.bool,
            onUnfollowCompanyClick: PropTypes.func,
            onFollowCompanyClick: PropTypes.func,
            numberOfFollowers: PropTypes.number,
        }),
    };

    handleFollowClick = (event) => {
        const { followCompany } = this.props;
        if (followCompany.isFollowing) {
            followCompany.onUnfollowCompanyClick(event);
        } else {
            followCompany.onFollowCompanyClick(event);
        }
    };

    render() {
        const { followCompany } = this.props;
        if (!followCompany || !followCompany.detailsFetched) {
            return null;
        }
        const { isFollowing, inprogressFollowUnFollow: inprogress } =
            followCompany;
        return (
            <Consumer>
                {(context) => (
                    <div className="u-no-break u-position-relative">
                        <span className="u-mr16">
                            {followCompany.numberOfFollowers} {i18n.followers}
                        </span>
                        <button
                            className={cx(
                                {
                                    'button--cta': !inprogress && !isFollowing,
                                    'button--in-progress': inprogress,
                                },
                                'button'
                            )}
                            onClick={(event) => {
                                context.setActiveFollowButton(this.props.id);
                                this.handleFollowClick(event);
                            }}
                            ref={(el) => {
                                this.button = el;
                            }}
                        >
                            {isFollowing ? i18n.following : i18n.follow}
                        </button>
                    </div>
                )}
            </Consumer>
        );
    }
}

export default FollowButton;
